
//React
import React, { CSSProperties, useId } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'


//component
import { Routes } from '../routes'
import { iUser } from './type'
import { performAppLogout } from '../utils/performAppLogout'
import { useTheme } from '../contexts/ThemeContext'


//interface

interface ChildProps {
    dropName?: React.ReactNode
    iconClassName?: string
    buttonDropClassName?: string
    dropdownType?: string
    styleButton?: CSSProperties
    deleteProcess?: () => void
    action1?: string
    action2?: string
    action3?: string
    action4?: string
    action5?: string
    action6?: string
    theRouteOfAction5: string
    theRouteOfAction4: string
    dataBsTarget?: string
    faq?: string
    routeFaq?: string
    updateMyCompany?: string
    edit?: string
    dataBsTargetEdit?: string
    publish?: string
    dataBsTargetPublish?: string
    dataBsTargetAction6?: string
    aproval?: string
    rename?: string
    share?: string
    invitedAproval?: () => void
    renameAction?: () => void
    shareAction?: () => void
    activeFocusdisa?: () => void
    activeFocusa?: () => void
    runEditor?: () => void
    backToHome?: () => void
    onClick?: (event: React.MouseEvent) => void
    exportToPDF?: () => void
    exportToPNG?: () => void
    exportToCSV?: (type: string) => void
    exportToXES?: (type: string) => void
    changeLanguage?: (lang: string) => void
    requestApproval?: string
    close?: string
    approve?: string
    disapprove?: string
    editdiadram?: string
    exportt?: boolean
    lang?: boolean
    dataBsTargetAction7?: string
    action7OnClick?: () => void
    action7?: string,
    /** Co-propriétaire — affiché en tête de menu (ex. cible data-bs #addProcessOwner{processId}) */
    addProcessOwner?: string
    addProcessOwnerDataBs?: string
    /** Ouvre la modale côté parent (montage paresseux, ex. accueil). Prioritaire sur addProcessOwnerDataBs. */
    addProcessOwnerOnClick?: () => void
    link?: string,
    href?: string,
    prepareAndShowModal?: ((user: iUser | undefined) => void) | undefined;
    col?: iUser | undefined
    enableEdit?: string;
    classMenu?: string;
    onClickAction?: () => void;
    buttonLabel?: string;
    onclickAction4?: () => void;
    onclickAction5?: () => void;
    /** Clic sur le bouton d’ouverture du menu (icône ⋯) — ex. stats UI. */
    onMenuButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Dropdown = (props: ChildProps) => {
    const {
        close,
        approve,
        disapprove,
        editdiadram,
        onClick,
        invitedAproval,
        requestApproval,
        runEditor,
        backToHome,
        activeFocusdisa,
        activeFocusa,
        renameAction,
        shareAction,
        aproval,
        rename,
        share,
        dataBsTargetPublish,
        dataBsTargetAction6,
        publish,
        routeFaq,
        faq,
        dropName,
        iconClassName,
        buttonDropClassName,
        dropdownType,
        styleButton,
        deleteProcess,
        exportToPDF,
        exportToPNG,
        exportToCSV,
        exportToXES,
        changeLanguage,
        action1,
        action2,
        action3,
        action4,
        action5,
        action6,
        action7,
        theRouteOfAction5,
        theRouteOfAction4,
        dataBsTarget,
        updateMyCompany,
        dataBsTargetEdit,
        edit,
        exportt,
        lang,
        dataBsTargetAction7,
        action7OnClick,
        addProcessOwner,
        addProcessOwnerDataBs,
        addProcessOwnerOnClick,
        link,
        href,
        prepareAndShowModal,
        col,
        enableEdit,
        classMenu,
        onClickAction,
        buttonLabel,
        onclickAction5,
        onclickAction4,
        onMenuButtonClick,

    } = props
    const { t } = useTranslation()
    const { theme } = useTheme()
    const reactId = useId().replace(/:/g, '')
    const dropdownBtnId = `famla-dd-btn-${reactId}`

    const hideOpenDropdown = (e: React.MouseEvent<HTMLElement>) => {
        const root = e.currentTarget.closest('.dropdown')
        const toggle = root?.querySelector<HTMLElement>('[data-bs-toggle="dropdown"]')
        const Bs = (window as {
            bootstrap?: { Dropdown?: { getOrCreateInstance: (el: Element) => { hide: () => void } } }
        }).bootstrap
        if (toggle && Bs?.Dropdown) {
            Bs.Dropdown.getOrCreateInstance(toggle).hide()
        }
    }

    const handleClick = () => {
        prepareAndShowModal?.(col)
    };



    return (
        <>
            <div onClick={onClick} className={dropdownType} >
                <button
                    style={styleButton}
                    className={`dropdown-toggle ${buttonDropClassName}`}
                    type="button"
                    id={dropdownBtnId}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={(e) => onMenuButtonClick?.(e)}
                >
                    {iconClassName ? <span><i className={iconClassName}></i></span> : null}
                    {dropName}
                </button>
                <ul
                    className={`dropdown-menu small border ${theme === 'light' ? 'hdr-dd-popup' : 'dropdown-menu-dark border-secondary'} ${classMenu ?? ''}`}
                    aria-labelledby={dropdownBtnId}
                >
                    {addProcessOwner && addProcessOwnerOnClick && (
                        <li>
                            <button
                                type="button"
                                className="dropdown-item text-start w-100 text-decoration-none border-0"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    hideOpenDropdown(e);
                                    addProcessOwnerOnClick();
                                }}
                            >
                                {addProcessOwner}
                            </button>
                        </li>
                    )}
                    {addProcessOwner && !addProcessOwnerOnClick && addProcessOwnerDataBs && (
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                role="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    hideOpenDropdown(e);
                                    const Bs = (window as {
                                        bootstrap?: {
                                            Modal?: {
                                                getOrCreateInstance: (el: Element) => { show: () => void };
                                            };
                                        };
                                    }).bootstrap;
                                    const selector = addProcessOwnerDataBs.startsWith('#')
                                        ? addProcessOwnerDataBs
                                        : `#${addProcessOwnerDataBs}`;
                                    window.requestAnimationFrame(() => {
                                        const modalEl = document.querySelector(selector);
                                        if (modalEl && Bs?.Modal) {
                                            Bs.Modal.getOrCreateInstance(modalEl).show();
                                        }
                                    });
                                }}
                            >
                                {addProcessOwner}
                            </a>
                        </li>
                    )}
                    {action3 && <li><a className="dropdown-item" data-bs-target={dataBsTarget} data-bs-toggle='modal' href="#/">{action3}</a></li>}
                    {publish && <li><a className="dropdown-item" data-bs-target={dataBsTargetPublish} data-bs-toggle='modal' href="#/">{publish}</a></li>}
                    {action7 && (
                        <li>
                            {action7OnClick ? (
                                <button
                                    type="button"
                                    className="dropdown-item text-start w-100 text-decoration-none border-0"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        hideOpenDropdown(e);
                                        action7OnClick();
                                    }}
                                >
                                    {action7}
                                </button>
                            ) : (
                                <a className="dropdown-item" data-bs-target={dataBsTargetAction7} data-bs-toggle="modal" href="#/">
                                    {action7}
                                </a>
                            )}
                        </li>
                    )}
                    {edit && <li><a className="dropdown-item" data-bs-target={dataBsTargetEdit} data-bs-toggle='modal' href="#/">{edit}</a></li>}
                    {aproval && <li><button onClick={invitedAproval} className="dropdown-item  text-decoration-none border-0">{aproval}</button></li>}
                    {rename && <li><button onClick={renameAction} className="dropdown-item  text-decoration-none border-0">{rename}</button></li>}
                    {share && <li><button onClick={shareAction} className="dropdown-item  text-decoration-none border-0">{share}</button></li>}
                    {requestApproval && <li><a className="dropdown-item" data-bs-target={'#requestApproval'} data-bs-toggle='modal' href="#/">{requestApproval}</a></li>}
                    {updateMyCompany && <li><a className="dropdown-item" data-bs-target={'#changeCompany'} data-bs-toggle='modal' href="#/">{updateMyCompany}</a></li>}
                    {faq && <li><Link className="dropdown-item  text-decoration-none" to={routeFaq ? routeFaq : ""}>{faq}</Link></li>}
                    {action1?.trim() && <li><button onClick={deleteProcess} className="dropdown-item  text-decoration-none border-0">{action1}</button></li>}

                    {action4 && <li onClick={onclickAction4}><Link className="dropdown-item text-decoration-none" to={theRouteOfAction4}>{action4}</Link></li>}
                    {action6 && <li ><a className="dropdown-item" data-bs-target={dataBsTargetAction6} data-bs-toggle='modal' href="#/">{action6}</a></li>}
                    {link && <li><a className="dropdown-item" href={href}>{link}</a></li>}
                    {action2 && <li><button type="button" onClick={() => void performAppLogout()} className="dropdown-item text-decoration-none border-0" >{action2}</button></li>}
                    {action5 && <li onClick={onclickAction5}><Link className="dropdown-item  text-decoration-none " to={theRouteOfAction5}>{action5}</Link></li>}

                    {disapprove && <li><button onClick={activeFocusdisa} data-bs-target={'#disapprove'} data-bs-toggle={'modal'} className="dropdown-item text-theme fw-bold">{disapprove}</button></li>}
                    {approve && <li><button onClick={activeFocusa} data-bs-target={'#approve'} data-bs-toggle={'modal'} className="dropdown-item text-success fw-bold">{approve}</button></li>}
                    {editdiadram && <li> <button type="button" className="dropdown-item" onClick={(e) => { e.preventDefault(); e.stopPropagation(); runEditor?.(); }}>{editdiadram}</button></li>}
                    {buttonLabel && <li> <button className="dropdown-item" onClick={onClickAction}>{buttonLabel}</button></li>}

                    {exportt &&
                        <>
                            <li onClick={exportToPDF}><a className="dropdown-item" href="#/">{t('features.swimlane.exportPDF')}</a></li>
                            <li onClick={exportToPNG}><a className="dropdown-item" href="#/">{t('features.swimlane.exportPNG')}</a></li>
                            <li onClick={() => exportToCSV?.("csv")}><a className="dropdown-item" href="#/">{t('features.swimlane.exportCSV')}</a></li>
                            <li onClick={() => exportToXES?.('xes')}><a className="dropdown-item" href="#/">{t('features.swimlane.exportXES')}</a></li>
                        </>
                    }

                    {lang &&
                        <>
                            <li onClick={() => changeLanguage?.('fr')}><a className="dropdown-item" href="#/">{t('words.french')}</a></li>
                            <li onClick={() => changeLanguage?.('en')}><a className="dropdown-item" href="#/">{t('words.english')}</a></li>
                        </>
                    }

                    {close && <li onClick={backToHome}><a className="dropdown-item" href="#/">{close}</a></li>}
                    {enableEdit && <li onClick={handleClick}><a className="dropdown-item" href="#/">{enableEdit}</a></li>}


                </ul>
            </div>


        </>



    )
}
export default Dropdown